// Module
var code = `<section id="customer-loans">
        <div class="container--with-mini-menu">
          <div>
            <table class="table accordion collapse-borders" id="accordion">
              <thead>
              <tr>
                <th>No</th>
                <th>Date Granted</th>
                <th>Total active loans</th>
                <th>Total loans</th>
                <th>Total Outstanding principal balance</th>
                <th>
                </th>
              </tr>
              </thead>
              <tbody class="accordion-group" ng-repeat="item in \$ctrl.batches">
              <tr class="accordion-heading accordion-toggle"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  data-target="#{{'batch-individuals-' + \$index}}"
                  ng-click="\$ctrl.selectBatch(item)"
                  ng-class="{'selected': item == \$ctrl.batch, 'orange': item.status == 'INVALID'}"
              >
                <td>{{\$index + 1}}</td>
                <td>{{item.grantDate | prettyDate}}</td>
                <td>{{item.totalActiveLoans + ' loans'}}</td>
                <td>{{item.totalLoans + ' loans'}}</td>
                <td>{{item.totalPrincipalBalance | nxCurrency}}</td>
                <td>
                  <i class="pull-right" ng-class="item === \$ctrl.batch ? 'icon-chevron-down' : 'icon-chevron-up'"></i>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="remove-padding">
                  <div class="accordion-body collapse" id="{{'batch-individuals-' + \$index}}">
                    <batch-individual-loans batches="[item]"></batch-individual-loans>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="mini-menu right-details" ng-show="\$ctrl.batch">
            <div class="tab-content">
              <div class="tab-pane active" id="operations">
                <div class="operation-row">
                  <div class="btn-group" ng-if="\$ctrl.atLeastOneUnreleasedLoan(\$ctrl.batch.loans)" >
                    <button class="btn btn-success dropdown-toggle" data-toggle="dropdown">Release <span class="caret"></span></button>
                    <ul class="dropdown-menu">
                      <li><a ng-click="\$ctrl.releaseGroupByCC()" command-access="ReleaseGroupLoanByCC">{{'RELEASE_CC' | translate:'GROUP_LOAN'}}</a></li>
                      <li><a ng-click="\$ctrl.releaseGroupByCash()" command-access="ReleaseGroupLoanByCash">Release Gr. by cash</a></li>
                    </ul>
                  </div>
                  <div class="btn-group">
                    <button class="btn btn-success dropdown-toggle" data-toggle="dropdown">Prints <span class="caret"></span></button>
                    <ul class="dropdown-menu">
                      <li><a ng-click="\$ctrl.disbursmentForm()">Disbursement Form</a></li>
                      <li><a ng-click="\$ctrl.disbursmentWithSignatures()">Disbursement with signatures</a></li>
                      <li><a ng-click="\$ctrl.paymentReport()">Payment report</a></li>
                    </ul>
                  </div>
                  <span>
                    <button class="btn btn-danger" command-access='DeleteGroupLoan' ng-click="\$ctrl.deleteBatch()">Delete</button>
                  </span>
                  <span>
                    <button class="btn btn-inverse" command-access='AssignLoanBatchToGroup' ng-click="\$ctrl.assignLoanBatchToGroup()">Assign</button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/loans/batch/group-loans-batch.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;